import { Jodit } from 'jodit';

const buttons = [
	'bold',
	'italic',
	'underline',
	'strikethrough',
	'eraser',
	'|',
	'brush',
	'redo',
	'undo',
	'|',
	'align',
	'|',
	'ul',
	'ol',
	'|',
	'font',
	'fontsize',
	'|',
	'indent',
	'outdent',
	'|',
	'lineHeight',
	'|',
	'superscript',
	'subscript',
	'|',
	'table',
];

const minimalButtons = [
	'bold',
	'italic',
	'underline',
	'strikethrough',
	'eraser',
	'|',
	'brush',
	'redo',
	'undo',
	'|',
	'align',
	'|',
	'ul',
	'ol',
	'|',
	'font',
	'fontsize',
	'|',
	'indent',
	'outdent',
	'|',
	'lineHeight',
	'|',
	'superscript',
	'subscript',
];

const controls = {
	font: {
		list: Jodit.atom({
			KhmerOSSiemreap: 'Khmer OS Siemreap',
			KhmerOSMuolLight: 'Khmer OS Muol Light',
		}),
	},
	lineHeight: { list: Jodit.atom([1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2]) },
};

const style = {
	fontFamily: 'KhmerOSSiemreap',
	fontSize: '16px',
};

const constants = { buttons, minimalButtons, controls, style };

export default constants;
